import { useCancelResearch } from "@app/queries/research";
import { confirm } from "@lib/common/components/modals/modals";
import { Text } from "@mantine/core";

export function useDeepResearch() {
  const cancelMutation = useCancelResearch();

  const cancelSession = (sessionId: string) => {
    confirm({
      title: "Stop deep research",
      children: <Text>Are you sure you want to stop this deep research session?</Text>,
      labels: { confirm: "Yes, stop it", cancel: "Cancel" },
      onConfirm: () => cancelMutation.mutate({ params: { path: { session_id: sessionId } } }),
      danger: true
    });
  };

  return {
    cancelSession,
    cancelMutation
  };
}
